import React from 'react';
import {connect} from 'react-redux';
import {Select as PolarisSelect, TextStyle} from '@shopify/polaris';
import Input from './input';

class Select extends Input {
  _render() {
    const {input} = this.props;
    const {error} = input;
    const placeholder = input.placeholder || 'Select one...';

    return (
      <div>
        <PolarisSelect
          id={input.handle}
          label={input.label}
          placeholder={placeholder}
          helpText={input.helpText}
          value={input.value}
          groups={input.options}
          onChange={this.handleChange}
          error={error}
        />
        <TextStyle>{this.description}</TextStyle>
      </div>
    );
  }
}

export default connect(
  Select.mapStateToProps,
  Select.mapDispatchToProps
)(Select);
